import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, FormControl, FormControlLabel, Radio, RadioGroup
} from "@mui/material";
import {PublishStatus} from "../../schemas/races/racesSchema";
import {useState} from "react";

interface RacePublishDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (status: PublishStatus) => void;
    newRace: boolean;
    defaultStatus?: PublishStatus;
}

const PublishDialog: React.FC<RacePublishDialogProps> = ({open, onClose, onConfirm, newRace, defaultStatus}) => {
    const [status, setStatus] = useState<PublishStatus>(defaultStatus ?? "UNPUBLISHED");

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStatus(event.target.value as PublishStatus);
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle> {newRace ? "Kam publikovat nově vytvořený závod?" : "Změna místa publikace"}</DialogTitle>
            <DialogContent>
                <FormControl>
                    <RadioGroup
                        value={status}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="UNPUBLISHED" control={<Radio/>} label={newRace ? "Nikam" : "Nepublikováno"}/>
                        <FormControlLabel value="ANNOUNCED" control={<Radio/>} label="Kalendář"/>
                        <FormControlLabel value="PUBLISHED" control={<Radio/>} label="Kalendář a přehled aktualit"/>
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Zrušit</Button>
                <Button onClick={() => onConfirm(status)} variant="contained"> {newRace ? "Vytvořit a publikovat" : "Potvrdit"}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PublishDialog;
